import { MapGeoLevel, MapLayerName } from '@/types';

export const mapLayerToGeoLevel = {
  [MapLayerName.CantonTileSet]: MapGeoLevel.Canton,
  [MapLayerName.MunicipalityTileSet]: MapGeoLevel.Municipality,
  [MapLayerName.TownTileSet]: MapGeoLevel.Town,
};

export const getIaziId = (level: MapGeoLevel, id?: number | string): string => {
  if (!id) {
    return '';
  }
  return `iazi-${level}-${id}`.toLowerCase();
};
